<template>
    <div>
        <div class="header-container">
            <div class="header-top">
                <h2 class="logo">
                    <i href="javascript:;" title="金榜志愿通" @click="refreshHtml">
                    <img src="../assets/images/logo.jpg" style="width:85%;height:85%;"/>
                    </i>
                </h2>
            <!-- <div class="header-md">
                <el-input v-model="searchContent" placeholder="查大学/查专业/搜问答" style="width:400px;">
                    <el-button slot="append">搜索</el-button>
                </el-input>
            </div> -->
            <!-- color:#ff9966 {{gkYear2}}年-->
            <div style="display: block;">
                <div style="font-size:15px;color:#ff9966;font-weight:bold;"
                v-if="isShowGKMsg1">
                距离{{gkYear}}年高考还有 <span style="color:blue;font-size:20px;">{{days}} </span>天
                </div>
                <div style="font-size:15px;color:#ff861a;font-weight:bold;
                width: 260px;
                "
                v-else-if="isShowGKMsg2">
                距离{{gkYear2}}年高考志愿填报还有 <span style="color:blue;font-size:20px;">{{days2}} </span>天
                </div>
                <div style="font-size:15px;color:#ff861a;font-weight:bold;
                width: 260px;
                " v-else-if="isShowGKMsg3">
                今天是高考志愿填报第 <span style="color:blue;font-size:20px;">{{days3}} </span>天
                </div>
                <div v-else-if="isShowGKMsg4"
                 style="font-size:15px;color:#ff9966;font-weight:bold;">
                距离{{gkYear3}}年高考还有 <span style="color:blue;font-size:20px;">{{days4}} </span>天
                </div>
            </div>
        <div class="header-md">
            <div class="md-change"  v-if="token">
                <el-form :model="ruleForm"  :inline="true" style="width:100%" size="mini">
                <el-form-item label="首选科目:" prop="sxkm" v-if="userInfo.yhlb===7||userInfo.yhlb===9">
                    <el-select style="width:70px;" v-if="sxkms.length>0" v-model="userInfo.sxkm" @change="changeSxkm">
                        <el-option v-if="sxkms.length===0" disabled value="-1">
                            <i class="el-icon-loading" style="font-size: 16px;"></i>
                        </el-option>
                        <template v-if="sxkms.length>0">
                        <el-option v-for="(item,index) in sxkms"
                        :key="index" :label="item.name" :value="item.value"></el-option>
                        </template>
                    </el-select>
                </el-form-item>
            </el-form>
            </div>
            <div class="header-user" v-if="token">
                <template v-if="userInfo.sssf===43||userInfo.sssf===44">
                <span v-if="userInfo.sxkm===2">物理/</span>
                <span v-if="userInfo.sxkm===1">历史/</span>
                <span v-if="(userInfo.zxkma===1&&userInfo.zxkmb===2)
                ||(userInfo.zxkmb===1&&userInfo.zxkma===2)">政治/地理 </span>
                <span v-if="(userInfo.zxkma===1&&userInfo.zxkmb===3)
                ||(userInfo.zxkmb===1&&userInfo.zxkma===3)">化学/政治</span>
                <span v-if="(userInfo.zxkma===1&&userInfo.zxkmb===4)
                ||(userInfo.zxkmb===1&&userInfo.zxkma==4)">政治/生物</span>
                <span v-if="(userInfo.zxkma===2&&userInfo.zxkmb===3)
                ||(userInfo.zxkmb===2&&userInfo.zxkma==3)">化学/地理 </span>
                <span v-if="(userInfo.zxkma===2&&userInfo.zxkmb===4)
                ||(userInfo.zxkmb===2&&userInfo.zxkma==4)">地理/生物</span>
                <span v-if="(userInfo.zxkma===3&&userInfo.zxkmb===4)
                ||(userInfo.zxkmb===3&&userInfo.zxkma==4)">化学/生物</span>
                </template>
                <template v-if="userInfo.sssf===51">
                <span v-if="userInfo.sxkm===1">文科</span>
                <span v-if="userInfo.sxkm===2">理科</span>
                </template>
                <span>
                    <strong class="score">{{userInfo.gkfs}}</strong>分
                </span>
            </div>
            <div class="header-rt">
                 <el-button type="primary" size="small" @click="loginOutCode">退出</el-button>
                </div>
        </div>
            <div class="header-bottom">
                <!-- <el-select v-model="provinceId" style="width:100px;" size="small"></el-select> -->
                <!-- <el-button type="primary" size="small" style="margin-left:15px;">登录</el-button> -->
                <!-- <el-button type="primary" size="small">注册</el-button> -->
            </div>
            </div>
            <div class="header-nav">
                <!-- <ul class="nav-item">
                <li :class="{current: $route.path.includes('/main/home')}"><router-link  to="/main/home" >首页</router-link></li>
                <li :class="{current: $route.path.includes('/zypg')}">
                    <router-link to="/zypg" >志愿评估</router-link>
                </li>
                <li :class="{current: $route.path.includes('/schoolRecommend')}"><router-link to="/schoolRecommend" ><span @click="clearYxtj">院校推荐</span></router-link></li>
                <li :class="{current: $route.path.includes('/schoolfinder')}"><router-link to="/schoolfinder"><span @click="clearYxcx">院校查询</span></router-link></li>
                <li :class="{current: $route.path.includes('/majorquery')}"><router-link to="/majorquery">专业查询</router-link></li>
                <li :class="{current: $route.path.includes('/datahome')}"><router-link to="/datahome">数据查询</router-link></li>
                <li :class="{current: $route.path.includes('/me')}"><router-link to="/me">用户中心</router-link></li>
                <li :class="{current: $route.path.includes('/buyindex')}" ><router-link to="/buyindex" >在线购买</router-link></li>
                <li :class="{current: $route.path.includes('/qjPlan')}"><router-link to="/qjPlan"> 强基计划</router-link></li>
                <li><a href="http://www.zy1dt.cn" target="_blank"><i class="el-icon-s-promotion"></i>艺考系统入口</a></li>
                </ul> -->
                <ul class="nav-item">
                    <li :class="{current: $route.path.includes('/main/home')}">
                        <router-link to="/main/home">首页</router-link>
                    </li>
                    <li @mouseenter="clickShowErji" @mouseleave="clickShowErji2">
                        <span>高考选科</span>
                        <span class="el-icon-caret-bottom"></span>
                        <ul v-if="isShowQDMB" class="nav-item2">
                            <li :class="{current: $route.path.includes('/main/queryZhiYe')}">
                                <router-link to="/main/queryZhiYe">职业查询</router-link>
                            </li>
                            <li :class="{current: $route.path.includes('/main/datahome')}">
                                <router-link to="/main/datahome">数据查询</router-link>
                            </li>
                            <!--  @mouseenter="clickShowDuoYuanShengXue" @mouseleave="clickShowDuoYuanShengXue2" -->
                            <li :class="{current: $route.path.includes('/main/DuoYuanShengXue')}">
                            <router-link to="/main/DuoYuanShengXue" @click="$store.commit('initIsUpdateToken');">多元升学</router-link>
                            <!-- <span class="el-icon-caret-bottom"></span>
                            <ul class="nav-item3" v-if="isShowDYSX">
                                <li :class="{current: $route.path.includes('/main/qjPlan')}">
                                    <router-link to="/main/qjPlan">强基计划</router-link>
                                </li>
                                <li>师范生</li>
                            </ul> -->
                            </li>
                            <!--  @mouseenter="clickShowZhiYeCePing" @mouseleave="clickShowZhiYeCePing2" -->
                            <li>
                                <!-- href="http://ceping.zy1dt.com/ceping/list.jhtml" target="_blank" -->
                                <a href="http://ceping.zy1dt.com/ceping/list.jhtml" target="_blank">测评工具</a>
                                <!-- <span class="el-icon-caret-bottom"></span>
                                <ul class="nav-item4" v-if="isShowZYCP">
                                    <li>
                                        <a href="http://ceping.zy1dt.com/ceping/detail/1.jhtml">MBTI职业性格测评</a>
                                    </li>
                                    <li>
                                        <a href="http://ceping.zy1dt.com/ceping/detail/2.jhtml">（2）霍兰德职业兴趣测评 </a>
                                    </li>
                                    <li>
                                        <a href="http://ceping.zy1dt.com/ceping/detail/3.jhtml">（3）SAS焦虑自评量表</a>
                                    </li>
                                </ul> -->
                            </li>
                            <li :class="{current: $route.path.includes('/main/chooseSubjectCp')}">
                                <router-link to="/main/chooseSubjectCp">选科模拟</router-link>
                            </li>
                        </ul>
                    </li>
                    <li :class="{current: $route.path.includes('/main/schoolRecommend')}">
                        <router-link to="/main/schoolRecommend">志愿推荐</router-link>
                    </li>
                    <!-- <li @mouseenter="clickShowYxtj" @mouseleave="clickHiddenYxtj">
                        <span>志愿推荐</span>
                        <span class="el-icon-caret-bottom"></span>
                        <ul v-if="isShowSchoolReCommand" class="nav-item2">
                            <li :class="{current: $route.path.includes('/main/schoolRecommend')}">
                                <router-link to="/main/schoolRecommend">文化生</router-link>
                            </li>
                            <li :class="{current: $route.path.includes('/main/yshSchoolRecommend')}">
                                <router-link to="/main/yshSchoolRecommend">艺术生</router-link>
                            </li>
                        </ul>
                    </li> -->
                    <li :class="{current: $route.path.includes('/main/zypg')}">
                        <router-link to="/main/zypg">志愿评估</router-link>
                    </li>
                    <!--  @mouseenter="clickShowJianKongYuTiaoZheng" @mouseleave="clickShowJianKongYuTiaoZheng2" -->
                                            <!-- <span class="el-icon-caret-bottom"></span>
                        <ul v-if="isShowJKYTZ" class="nav-item2">
                            <li :class="{current: $route.path.includes('/main/schoolRecommend')}">
                                <router-link to="/main/schoolRecommend">院校推荐</router-link>
                            </li>
                        </ul> -->
                    <li :class="{current: $route.path.includes('/main/schoolfinder')}">
                        <router-link to="/main/schoolfinder">院校查询</router-link>
                    </li>
                    <!-- <li @mouseenter="clickShowYxcx" @mouseleave="clickHiddenYxcx">
                        <span>院校查询</span>
                        <span class="el-icon-caret-bottom"></span>
                        <ul v-if="isShowSchoolFinder" class="nav-item2">
                            <li :class="{current: $route.path.includes('/main/schoolfinder')}">
                                <router-link to="/main/schoolfinder">文化生</router-link>
                            </li>
                            <li :class="{current: $route.path.includes('/main/yshSchoolFinder')}">
                                <router-link to="/main/yshSchoolFinder">艺术生</router-link>
                            </li>
                        </ul>
                    </li> -->
                    <li :class="{current: $route.path.includes('/main/majorquery')}">
                        <router-link to="/main/majorquery">专业查询</router-link>
                    </li>
                    <!-- <li @mouseenter="clickShowZycx" @mouseleave="clickHiddenZycx">
                        <span>专业查询</span>
                        <span class="el-icon-caret-bottom"></span>
                        <ul v-if="isShowMajor" class="nav-item2">
                            <li :class="{current: $route.path.includes('/main/majorquery')}">
                                <router-link to="/main/majorquery">文化生</router-link>
                            </li>
                            <li :class="{current: $route.path.includes('/main/yshMajorQuery')}">
                                <router-link to="/main/yshMajorQuery">艺术生</router-link>
                            </li>
                        </ul>
                    </li> -->
                    <li :class="{current: $route.path.includes('/main/me')}">
                        <router-link to="/main/me">用户中心</router-link>
                    </li>
                    <li :class="{current: $route.path.includes('/main/buyindex')}">
                        <router-link to="/main/buyindex" >在线购买</router-link>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</template>
<script>
// icon="el-icon-search"
import {mapState} from 'vuex';
import { addPage, clearAllPage, getCurrentOpenPageList, getCurrentPage } from '../common/loginout';
export default {
data(){
    return{
        searchContent:"",
        provinceId:"43",
        isShowQDMB:false,
        isShowZDJH:false,
        isShowSSFA:false,
        isShowJKYTZ:false,
        isShowDYSX:false,
        isShowZYCP:false,
        gkYear:"",
        days:"",
        gkYear2:"",
        gkYear3:"",
        days2:"",
        days3:"",
        days4:"",
        isShowGKMsg1:false,
        isShowGKMsg2:false,
        isShowGKMsg3:false,
        isShowGKMsg4:false,
        hours:"",
        minutes:"",
        second:"",
        gkTimer:null,
        ruleForm:{
            selectedSf:"",
            sxkm:""
        },
        sxkms:[],
        isShowSchoolReCommand:false,
        isShowSchoolFinder:false,
        isShowMajor:false
    };
},
methods:{
    refreshHtml(){
        let href="";
        if (location.href.indexOf("#") !== -1) {
            href = location.href.substring(0, location.href.indexOf("#"));
        }
        location.href =href;
    },
    async tocePing(){
        // const res=await this.$http.getHttp("http://ceping.zy1dt.com/ceping/list.jhtml");
        // console.log(res);
    },
    clearYxcx(){},
    clearYxtj(){},
    clickShowYxtj(){
        this.isShowSchoolReCommand=true;
    },
    clickHiddenYxtj(){
        this.isShowSchoolReCommand=false
    },
    clickShowYxcx(){
        this.isShowSchoolFinder=true;
    },
    clickHiddenYxcx(){
        this.isShowSchoolFinder=false
    },
    clickShowZycx(){
        this.isShowMajor=true;
    },
    clickHiddenZycx(){
        this.isShowMajor=false
    },
    clickShowErji(){
        this.isShowQDMB=true;
        this.isShowZDJH=false;
        this.isShowSSFA=false;
        this.isShowJKYTZ=false;
    },
    clickShowErji2(){
        this.isShowQDMB=false;
        this.isShowDYSX=false;
        this.isShowZYCP=false;
    },
    clickShowZhiDingJiHua(){
        this.isShowZDJH=true;
        this.isShowQDMB=false;
        this.isShowSSFA=false;
        this.isShowJKYTZ=false;
    },
    clickShowZhiDingJiHua2(){
        this.isShowZDJH=false;
    },
    clickShowShiShiFangAn(){
        this.isShowSSFA=true;
        this.isShowQDMB=false;
        this.isShowZDJH=false;
        this.isShowJKYTZ=false;
    },
    clickShowShiShiFangAn2(){
        this.isShowSSFA=false;
    },
    clickShowJianKongYuTiaoZheng(){
        this.isShowJKYTZ=true;
        this.isShowQDMB=false;
        this.isShowZDJH=false;
        this.isShowSSFA=false;
    },
    clickShowJianKongYuTiaoZheng2(){
        this.isShowJKYTZ=false;
    },
    clickShowDuoYuanShengXue(){
        this.isShowDYSX=true
        this.isShowJKYTZ=false;
        this.isShowZDJH=false;
        this.isShowSSFA=false;
        this.isShowZYCP=false;
    },
    clickShowDuoYuanShengXue2(){
        this.isShowDYSX=false;
    },
    clickShowZhiYeCePing(){
        this.isShowZYCP=true;
        this.isShowJKYTZ=false;
        this.isShowZDJH=false;
        this.isShowSSFA=false;
        this.isShowDYSX=false;
    },
    clickShowZhiYeCePing2(){
        this.isShowZYCP=false;
    },
    // 获取首选科目
    async getSxkm(){
        const res=await this.$http.getHttp("/zsjh/getSxkms");
        if(res.data.code===200){
            const sxkms=[];
            const data=res.data.obj;
            for(let i=0;i<data.length;i++){
                if(data[i].sxkmmc){
                    sxkms.push({name:data[i].sxkmmc,value:data[i].sxkm});
                }
            }
            this.sxkms=sxkms;
        }else if(res.data.code===500){
            if(res.data.message){
                this.$message({message:res.data.message,type:'error'});
            }
        }else if(res.status===401){
            this.$message({message: '登录超时，请重新登录',type:"error"});
            await this.$store.dispatch("loginOut",{sjhm:this.userInfo.sjhm});
            this.$router.replace({
                path: '/main/home',
                query: {redirect: this.$router.currentRoute.fullPath}
            });
        }else if(res.data.code===0){
            this.$message({message:"您的账号在其他地点登陆了！",showClose:true,type:'warning'});
            await this.$store.dispatch("loginOut",{sjhm:this.userInfo.sjhm});
            this.$router.replace({
                path: '/main/home',
                query: {redirect: this.$router.currentRoute.fullPath}
            });
        }else if(res.status===409||res.status===410||res.status===411){
            this.$message({message:"您的账号在其他地点登陆了！",showClose:true,type:"warning"});
            await this.$store.dispatch("loginOut",{sjhm:this.userInfo.sjhm});
            this.$router.replace({
                path: '/main/home',
                query: {redirect: this.$router.currentRoute.fullPath}
            });
        }
        this.ruleForm.sxkm=this.userInfo.sxkm;
    },
        // 切换首选科目
    async changeSxkm(sxkm){
        const res=await this.$http.getHttp("/users/updateKl?kl="+sxkm);
        if(res.data.code===200){
            await this.getUserInfo();
        }else if(res.data.code===500){
            if(res.data.message){
                this.$message({message:res.data.message,type:'error'});
            }
        }else if(res.status===401){
            this.$message({message: '登录超时，请重新登录',type:"error"});
            await this.$store.dispatch("loginOut",{sjhm:this.userInfo.sjhm});
            this.$router.replace({
                path: '/main/home',
                query: {redirect: this.$router.currentRoute.fullPath}
            });
        }else if(res.data.code===0){
            this.$message({message:"您的账号在其他地点登陆了！",showClose:true,type:'warning'});
            await this.$store.dispatch("loginOut",{sjhm:this.userInfo.sjhm});
            this.$router.replace({
                path: '/main/home',
                query: {redirect: this.$router.currentRoute.fullPath}
            });
        }else if(res.status===409||res.status===410||res.status===411){
            this.$message({message:"您的账号在其他地点登陆了！",showClose:true,type:"warning"});
            await this.$store.dispatch("loginOut",{sjhm:this.userInfo.sjhm});
            this.$router.replace({
                path: '/main/home',
                query: {redirect: this.$router.currentRoute.fullPath}
            });
        }
        this.$emit('reloadZypg', 'true');
    },
        // 获取用户信息
    async getUserInfo(){
        const res=await this.$http.getHttp("/users/getUserInfo?username="+this.userInfo.username);
        if(res.status===200){
            if(res.data.code===500){
            if(res.data.message){
                this.$message({message:res.data.message,type:'error'});
            }
            }else if(res.data.code===0){
            this.$message({message:"您的账号在其他地点登陆了！",showClose:true,type:'warning'});
            await this.$store.dispatch("loginOut",{sjhm:this.userInfo.sjhm});
            this.$router.replace({
                path: '/main/home',
                query: {redirect: this.$router.currentRoute.fullPath}
            });
            }else{
                this.$store.dispatch("saveUserInfo",res.data);
            }
        }else if(res.data.code===500){
            if(res.data.message){
                this.$message({message:res.data.message,type:'error'});
            }
        }else if(res.status===401){
            this.$message({message: '登录超时，请重新登录',type:"error"});
            await this.$store.dispatch("loginOut",{sjhm:this.userInfo.sjhm});
            this.$router.replace({
                path: '/main/home',
                query: {redirect: this.$router.currentRoute.fullPath}
            });
        }else if(res.data.code===0){
            this.$message({message:"您的账号在其他地点登陆了！",showClose:true,type:'warning'});
            await this.$store.dispatch("loginOut",{sjhm:this.userInfo.sjhm});
            this.$router.replace({
                path: '/main/home',
                query: {redirect: this.$router.currentRoute.fullPath}
            });
        }
    },
    setGkTimer(){
        this.gkTimer=setInterval(() => {
        const currentYear=new Date().getFullYear();
        const gaokaoDate=new Date(currentYear,5,7);
        const tianbaoDate=new Date(currentYear,5,26);
        const editSchoolDate=new Date(currentYear,6,1);
        if(new Date()<gaokaoDate){
            this.isShowGKMsg1=true;
            this.isShowGKMsg2=false;
            this.isShowGKMsg3=false;
            this.isShowGKMsg4=false;
            this.gkYear=gaokaoDate.getFullYear();
            // gaokaoDate.setFullYear(currentYear+1);
        }else if(new Date()>=gaokaoDate&&new Date()<=tianbaoDate){   
            this.isShowGKMsg1=false;
            this.isShowGKMsg2=true;
            this.isShowGKMsg3=false;
            this.isShowGKMsg4=false;
            this.gkYear2=currentYear;
        }else if(new Date()>tianbaoDate&&new Date()<=editSchoolDate){
            this.isShowGKMsg1=false;
            this.isShowGKMsg2=false;
            this.isShowGKMsg3=true;
            this.isShowGKMsg4=false;
            const dqMonth=new Date().getMonth()+1;
            const dqDay=new Date().getDate();
            const dqDate=new Date(currentYear,dqMonth-1,dqDay);
            const chaDays=Math.abs(Math.ceil((editSchoolDate-dqDate)/(1000*60*60*24)));
            const showTxt=6-chaDays;
            this.gkYear2=currentYear;
            this.days3=showTxt;
        }else if(new Date()>editSchoolDate&&new Date().getMonth()==6
        &&new Date().getDate()==1){
            this.isShowGKMsg1=false;
            this.isShowGKMsg2=false;
            this.isShowGKMsg3=true;
            this.isShowGKMsg4=false;
            const dqMonth=new Date().getMonth()+1;
            const dqDay=new Date().getDate();
            const dqDate=new Date(currentYear,dqMonth-1,dqDay);
            const chaDays=Math.abs(Math.ceil((editSchoolDate-dqDate)/(1000*60*60*24)));
            console.log(editSchoolDate);
            console.log(dqDate);
            console.log(chaDays);
            const showTxt=6-chaDays;
            this.gkYear2=currentYear;
            this.days3=showTxt;
        }else if(new Date()>editSchoolDate&&(new Date().getMonth()>6
        ||(new Date().getMonth()==6
        &&new Date().getDate()>1))){
            gaokaoDate.setFullYear(currentYear+1);
            this.gkYear3=currentYear+1;
            this.isShowGKMsg1=false;
            this.isShowGKMsg2=false;
            this.isShowGKMsg3=false;
            this.isShowGKMsg4=true;
            this.days4=Math.ceil((Math.abs(new Date()-gaokaoDate))/(1000*60*60*24));
        }
        const now=new Date();
        const cha=gaokaoDate-now;
        const cha2=tianbaoDate-now;
        if(cha>=0){
            this.days=Math.ceil(cha/(1000*60*60*24));
            // this.hours=Math.floor(cha%(1000*60*60*24)/(1000*60*60));
            // this.minutes=Math.floor(cha%(1000*60*60)/(1000*60));
            // this.second=Math.floor(cha%(1000*60)/1000);
        }else if(cha2>=0){
            this.days2=Math.ceil(cha2/(1000*60*60*24));
        }
    }, 1000);
    },
    loginOutCode(){
    this.$confirm('确认退出登录吗？', '提示',{type: 'warning'}).then(async (action) => {
          if(action === 'confirm'){
            //  const tokenObj=localStorage.getItem("token")?JSON.parse(localStorage.getItem("token")):{};
            //  const token=tokenObj.token;
            //  window.loginOutCount++;
            

             const sjhm=this.userInfo.sjhm;
             await this.$store.dispatch('loginOut',{sjhm});
             this.$router.replace('/main/home');
            //  console.log(token);
            //  console.log(window.__CANCEL_PERSIST);
            //  if(token){
            //     this.$store.commit("setIsLoginOut",{isLoginOut:true});
            //  }else if(!token){
            //     window.__CANCEL_PERSIST=true;
            //  }
          }
        }).catch((error) => {
          return error;
        });
    }
},
computed:{
    ...mapState(["userInfo","token"])
},
async mounted(){
    this.setGkTimer();
    await this.getSxkm();
},
beforeDestroy(){
    clearInterval(this.gkTimer);
}
};
</script>
<style scoped lang="less">
.header-container{
    .header-top{
        display:flex;
        justify-content:space-between;
        align-items:center;
        width:1200px;
        height:130px;
        margin:0 auto;
        position:relative;
    }
    .header-md{
        flex:1;
        display:flex;
        justify-content:flex-start;
        align-items:center;
        .md-change{
            flex: 1;
            // margin-left: 65px;
            margin-left:20px;
            padding-top: 12px;
            box-sizing: border-box;
        }
        .header-user{
            flex: 1;
            margin-right: 10px;
            text-align: right;
            font-size: 14px;
        }
        .score{
            // color:#f56c6c;
            color: #ff861a;
        }
    }
    .header-rt{
        width: 160px;
        text-align: left;
    }
    .header-nav{
        width:100%;
        height:40px;
        background-color:#409EFF;
        .nav-item{
            // min-width:1200px;
            max-width: 1200px;
            display:flex;
            justify-content:center;
            align-items:center;
            flex-flow:nowrap;
            color:#ffffff;
            li{
                flex-basis: 120px;
                height:40px;
                line-height:40px;
                cursor:pointer;
                text-align:center;
                list-style:none;
                a{
                    display:block;
                    color:#ffffff;
                    text-decoration:none;
                    &:-webkit-any-link{
                        text-decoration:none;
                    }
                    .router-link-active{
                        text-decoration:none;
                    }
                }
            }
            li.current{
                    background-color:#0479f5;
                }
        }
        .nav-item2{
            // min-width:1200px;
            position: absolute;
            color:#ffffff;
            z-index: 999;
            li{
                // flex-basis: 120px;
                width: 120px;
                height:40px;
                line-height:40px;
                cursor:pointer;
                text-align:center;
                list-style:none;
                background-color: #409EFF;
                a{
                    display:block;
                    color:#ffffff;
                    text-decoration:none;
                    &:-webkit-any-link{
                        text-decoration:none;
                    }
                    .router-link-active{
                        text-decoration:none;
                    }
                }
            }
            li.current{
                    background-color:#0479f5;
                }
        }
        .nav-item3{
            // min-width:1200px;
            position: absolute;
            top: 80px;
            left: 120px;
            color:#ffffff;
            z-index: 999;
            li{
                // flex-basis: 120px;
                width: 120px;
                height:40px;
                line-height:40px;
                cursor:pointer;
                text-align:center;
                list-style:none;
                background-color: #409EFF;
                a{
                    display:block;
                    color:#ffffff;
                    text-decoration:none;
                    &:-webkit-any-link{
                        text-decoration:none;
                    }
                    .router-link-active{
                        text-decoration:none;
                    }
                }
            }
            li.current{
                    background-color:#0479f5;
                }
        }
        .nav-item4{
            // min-width:1200px;
            position: absolute;
            top: 120px;
            left: 120px;
            color:#ffffff;
            z-index: 999;
            li{
                // flex-basis: 120px;
                width: 180px;
                height:40px;
                line-height:40px;
                cursor:pointer;
                text-align:center;
                list-style:none;
                background-color: #409EFF;
                a{
                    width: 180px;
                    display:block;
                    color:#ffffff;
                    text-decoration:none;
                    &:-webkit-any-link{
                        text-decoration:none;
                    }
                    .router-link-active{
                        text-decoration:none;
                    }
                }
            }
            li.current{
                    background-color:#0479f5;
                }
        }
    }
}
h1,h2,h3,h4,h5,h6{
    margin: 0 !important;
    font-weight: 700 !important;
}
</style>
